export default {
  obra: {
    value: null,
    maxlength: '20',
    required: false,
    state: null
  },
  obraID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  responsavel: {
    value: null,
    maxlength: '70',
    required: false,
    disabled: false,
    state: null
  },
  secaoRH: {
    value: null,
    maxlength: '20',
    required: false,
    state: null
  },
  secaoRHID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  localTrabalho: {
    value: null,
    maxlength: '20',
    required: false,
    state: null
  },
  localTrabalhoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  dataInicioSolicitacao: {
    value: null,
    maxlength: '10',
    required: true,
    disabled: false,
    state: null
  },
  dataFimSolicitacao: {
    value: null,
    maxlength: '10',
    required: true,
    disabled: false,
    state: null
  },
  cliente: {
    value: null,
    maxlength: '70',
    required: false,
    disabled: false,
    state: null
  },
  clienteID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  equipe: {
    value: null,
    maxlength: '70',
    required: false,
    disabled: false,
    state: null
  },
  paisID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  estadoID: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  cidadeID: {
    value: null,
    options: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/employeeboard/board/board-form.js